import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-1" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Resultater")
const _hoisted_3 = { class: "py-1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Informasjon")
const _hoisted_5 = { class: "py-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Påmelding")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: "mobile-nav border-bottom mb-3",
    onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('showNav');})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/info" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, { to: "/registration" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}